import { FormControlLabel, Radio, RadioGroup } from '@material-ui/core';
import React, { useEffect, useReducer, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  VIEW_ALL_STATUS_ACTIVE,
  VIEW_ALL_STATUS_INACTIVE,
} from '../../../constants/UiBuilderConst';
import { allUIBuilderPagesSelector } from '../../../layouts/property/propertySlice';
import CustomSelect from '../../form-controls/custom-select/Custom-Select';

const ViewAllSelector = (props) => {
  const { onValueChange, value, onViewAllStatusChange, isActive, error, areButtonsDisabled } =
    props;

  const [statusValue, setStatusValue] = useState(
    isActive ? VIEW_ALL_STATUS_ACTIVE : VIEW_ALL_STATUS_INACTIVE,
  );
  const originalPages = useSelector(allUIBuilderPagesSelector);

  useEffect(() => {
    setStatusValue(isActive ? VIEW_ALL_STATUS_ACTIVE : VIEW_ALL_STATUS_INACTIVE);
  }, [isActive]);

  useEffect(() => {
    onViewAllStatusChange(statusValue === VIEW_ALL_STATUS_ACTIVE);
  }, [statusValue]);

  const [formData, setFormData] = useReducer((state, newState) => ({ ...state, ...newState }), {
    redirectSelector: {
      value: '',
      fieldName: 'redirect page',
      errors: {},
      validations: [],
      tab: 0,
    },
  });

  useEffect(() => {
    const currFields = { ...formData };
    currFields.redirectSelector.value = value;
    formData.redirectSelector.validations = isActive ? ['required'] : [];
    currFields.redirectSelector.errors = error
      ? { required: `${currFields.redirectSelector.fieldName} is required` }
      : {};
    setFormData(currFields);
  }, [value, error]);

  useEffect(() => {
    onValueChange(formData.redirectSelector.value);
  }, [formData.redirectSelector.value]);

  const onStatusChange = (e) => {
    formData.redirectSelector.validations =
      e.target.value === VIEW_ALL_STATUS_ACTIVE ? ['required'] : [];
    setStatusValue(e.target.value);
    const redirectSelector = { ...formData.redirectSelector };
    redirectSelector.validations = e.target.value === VIEW_ALL_STATUS_ACTIVE ? ['required'] : [];
    setFormData({ redirectSelector });
  };

  return (
    <>
      <div className='col-md-12 redirect-selector mb-3'>
        <div className='row align-items-center mb-2 mt-3'>
          <div className='col-md-4 title'>View All</div>
          {!areButtonsDisabled && (
            <div className='col-md-8'>
              <RadioGroup
                row
                aria-label='statusValue'
                onChange={onStatusChange}
                value={statusValue}
                className='document-type'
                name='row-radio-buttons-group'
              >
                <FormControlLabel
                  value={VIEW_ALL_STATUS_ACTIVE}
                  control={<Radio color='primary' />}
                  label='Active'
                  className='me-5'
                />
                <FormControlLabel
                  value={VIEW_ALL_STATUS_INACTIVE}
                  control={<Radio color='primary' />}
                  label='Inactive'
                />
              </RadioGroup>
            </div>
          )}
        </div>
        {statusValue === VIEW_ALL_STATUS_ACTIVE && (
          <div className='col-md-10'>
            <CustomSelect
              item={formData.redirectSelector}
              handleInputChange={(e) => {
                setFormData({ redirectSelector: e });
              }}
              labelPrefix='Select'
              options={originalPages}
              hideNullOption={originalPages.length}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ViewAllSelector;
